import { Common } from '~/models/common';
import { Variables } from '~/models/variables';

export const variablesService = {
	fetch: async (): Promise<Variables.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
		};

		try {
			const response = await $fetch<Variables.Model[]>(Variables.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Variables:', error);

			return [];
		}
	},
};
